module.exports = __webpack_public_path__ + "img/img5.c11a868.png";